import uniq from "lodash-es/uniq";
import {deleteRequest, getRequest, postRequest, patchRequest} from "../api";
import {mapReqOptions, scrubId} from "../utils";

export const postIncident = (incident = {}) => {
  const newIncident = {},
    date = new Date(),
    opened = date.toLocaleString(navigator.language);

  Object.assign(newIncident, {
    title: `New incident ${opened}`,
    status: "New",
    confidence: "High",
    incident_time: {opened: date.toISOString()},
    ...incident
  });

  return postRequest("/incident", newIncident, {
    serverOptions: {privateProxyURL: true}
  });
};

/**
 * @param {String} incidentId incident-<INCIDENT_ID>
 * @returns {{promise: Promise<AxiosResponse<any, any>>, cancel: Canceler}} axios promise
 */
export const fetchIncident = incidentId => {
  return getRequest(`/incident/${incidentId}`, null, {
    serverOptions: {privateProxyURL: true}
  });
};

export const fetchIncidentList = (query, options) => {
  const reqData = {
    query,
    ...mapReqOptions(options)
  };

  return getRequest("/incident/search", reqData, {
    serverOptions: {privateProxyURL: true}
  });
};

export const fetchBundle = (ids, options = {}) => {
  const {include_related_entities = false, publicURL} = options;
  const idList = Array.isArray(ids) ? ids : [ids];

  return postRequest(
    `/bundle/export`,
    {
      ids: uniq(idList)
    },
    {
      queryParams: {include_related_entities},
      serverOptions: {
        privateURL: !publicURL,
        publicURL
      }
    }
  );
};

export const updateIncidentStatus = (incidentId, status) => {
  return postRequest(
    `/incident/${scrubId(incidentId)}/status`,
    {status},
    {
      serverOptions: {privateProxyURL: true}
    }
  );
};

export const fetchIncidentEvents = incidentId => {
  return getRequest(
    `/event/search`,
    {query: `entity.id:"${incidentId}"`},
    {
      serverOptions: {privateURL: true}
    }
  );
};

export const updateIncident = (incidentId, patch) => {
  return patchRequest(`/incident/${scrubId(incidentId)}`, patch, {
    serverOptions: {privateProxyURL: true}
  });
};

export const deleteIncident = ids => {
  return deleteRequest(
    "/bulk",
    {incidents: ids},
    {
      serverOptions: {privateProxyURL: true}
    }
  );
};

/**
 * @param {String} incidentId incident-<INCIDENT_ID>
 * @returns {{promise: Promise<AxiosResponse<any, any>>, cancel: Canceler}} axios promise
 */
export const fetchIncidentTactics = incidentId => {
  return getRequest(`/incident/${scrubId(incidentId)}/tactics`, null, {
    serverOptions: {privateProxyURL: true}
  });
};
